var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner",
          attrs: {
            visible: _vm.innerVisible,
            title: !_vm.showResultLog
              ? _vm.$t("CargoMsg.Cargo_BatchEditCharge")
              : _vm.dialogTitle,
            width: "1060px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _vm.hasUnlockingJob && !_vm.showResultLog
            ? _c("el-alert", {
                staticStyle: { margin: "0 20px 8px" },
                attrs: {
                  title: _vm.$t("SeaExport.UnlockApplyUnlockedBanner"),
                  type: "warning",
                  "show-icon": "",
                  closable: false
                }
              })
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showResultLog,
                  expression: "!showResultLog"
                }
              ],
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { height: "620px", padding: "0" }
            },
            [
              _c(
                "cargo-up-down-resize",
                {
                  staticStyle: {
                    "margin-left": "20px",
                    "margin-right": "20px"
                  },
                  attrs: {
                    "up-style": {
                      display: "flex",
                      flexDirection: "column",
                      paddingBottom: "5px",
                      height: "50%"
                    },
                    "down-style": {
                      display: "flex",
                      flexDirection: "column",
                      paddingTop: "5px",
                      height: "50%"
                    }
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "up" },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("span", { staticStyle: { "font-size": "16px" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_SetEditCondition"))
                            )
                          ]),
                          _c(
                            "div",
                            { staticStyle: { display: "inline-block" } },
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.showResultLog,
                                      expression: "!showResultLog"
                                    }
                                  ],
                                  attrs: { type: "primary" },
                                  on: { click: _vm.toAdd }
                                },
                                [_vm._v(_vm._s(_vm.$t("Payment.new")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.showResultLog,
                                      expression: "!showResultLog"
                                    }
                                  ],
                                  attrs: { type: "danger" },
                                  on: { click: _vm.toRemove }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Remove")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.showResultLog,
                                      expression: "!showResultLog"
                                    }
                                  ],
                                  attrs: { type: "primary" },
                                  on: { click: _vm.matchCharge }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_MatchCharge"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c("cargo-ag-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "config-module": _vm.modifySpecialCharge
                            ? "10010020"
                            : "1001002",
                          "grid-options": _vm.dgCharge.gridOptions,
                          "column-defs": _vm.dgChargeColumnDefs,
                          "row-data": _vm.dgCharge.rowData
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.dgCharge.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "template",
                    { slot: "down" },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ToBeEditCharge")))
                      ]),
                      _c("cargo-ag-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "config-module": _vm.modifySpecialCharge
                            ? "10010070"
                            : "1001007",
                          "grid-options": _vm.filterCharge.gridOptions,
                          "column-defs": _vm.filterChargeColumnDefs,
                          "row-data": _vm.filterCharge.rowData
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.filterCharge.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          ),
          _c(
            "label",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showResultLog,
                  expression: "showResultLog"
                }
              ],
              staticStyle: {
                width: "100%",
                verticalAlign: "middle",
                fontWeight: "bold",
                fontSize: "14",
                color: "red"
              }
            },
            [_vm._v(_vm._s(_vm.txtLog))]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showResultLog,
                  expression: "showResultLog"
                }
              ],
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { height: "350px", padding: "0" }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "1001003",
                  "show-side-bar": false,
                  "grid-options": _vm.logCharge.gridOptions,
                  "column-defs": _vm.logCharge.columnDefs,
                  "row-data": _vm.logCharge.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.logCharge.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: { padding: "10px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.showResultLog,
                      expression: "!showResultLog"
                    }
                  ],
                  staticStyle: {
                    float: "left",
                    "margin-left": "20px",
                    "font-size": "16px",
                    color: "#454545"
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_ToBeEditChargeSelected") +
                        _vm.filterCharge.selectedRowsCount
                    )
                  )
                ]
              ),
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.showResultLog,
                          expression: "!showResultLog"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.toSave }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showResultLog,
                          expression: "showResultLog"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.exportExcel }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ExportLog")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.innerVisible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }